<template>
  <div class="container">
    <div id="chart">
      <apexchart
        :key="`chart-key-${key}`"
        type="bar"
        height="250"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import { report } from "@/api/hopdong.js";
export default {
  data() {
    return {
      key: 0,
      data: {},
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: "Số lượng",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " Hợp đồng ";
            },
          },
        },
        colors: ["#0080FF", "#FF8000"],
      },
      name: [],
    };
  },
  mounted() {
    this.hanlde_getdata();
  },
  methods: {
    async hanlde_getdata() {
      const res = await report();
      this.data = res.data;
      this.handle_render_data(this.data);
    },
    handle_render_data() {
      let name = [];
      let contract_new = [];
      let contract_due_date = [];
      this.series = [];
      this.chartOptions.xaxis.categories = [];
      this.data.forEach((e) => {
        this.chartOptions.xaxis.categories.push("Tháng " + e.month);
        contract_new.push(e.contract_new);
        contract_due_date.push(e.contract_due_date);
      });
      this.series.push(
        {
          name: "Hợp đồng mới",
          data: contract_new,
        },
        {
          name: "Hợp đồng cần gia hạn",
          data: contract_due_date,
        }
      );
      this.key++;
    },
  },
  watch: {
    target: function () {
      return this.renderData();
    },
  },
};
</script>

<style>
.container {
  margin-top: 10px;
  width: 100%;
}
</style>
